import { gql } from '@apollo/client';

export default gql`
  mutation CancelPayments(
    $bookingReference: String!
    $paymentLocation: String
    $currency: Currency
    $hasHotel: Boolean
    $customerId: String
    $shouldCancelLoyalty: Boolean
  ) {
    cancelPayments(
      bookingReference: $bookingReference
      paymentLocation: $paymentLocation
      currency: $currency
      hasHotel: $hasHotel
      location: EBSC
      customerId: $customerId
      shouldCancelLoyalty: $shouldCancelLoyalty
    ) {
      reference
      totalPriceToBePaid
      payments {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        provider
        method
        amount: amountWithCurrency(currency: $currency)
        amountInOriginalCurrency: amountWithCurrency
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
        isPayout
        isBalance
        isSuccessful
        action @client
        display @client
      }
    }
  }
`;
